import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-apply_color",
  "use": "icon-apply_color-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" role=\"img\" aria-label=\"箭頭指向方塊圖示\" id=\"icon-apply_color\">\r\n  <!-- 細箭身（無圓角） -->\r\n  <rect x=\"6\" y=\"27\" width=\"20\" height=\"10\" />\r\n  <!-- 箭尖（向右） -->\r\n  <polygon points=\"26,22 26,42 38,32\" />\r\n  <!-- 方框（與箭尖相連） -->\r\n  <rect x=\"38\" y=\"16\" width=\"20\" height=\"32\" rx=\"2\" ry=\"2\" stroke-width=\"4\" fill=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol